<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title class="font-weight-bold justify-center">Catálogo de armas</v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="end" align="center">
                <v-col cols="3">
                  <TextButton @click="openRegistroArmaDialog"> REGISTRAR ARMA NUEVA </TextButton>
                </v-col>
                <v-col cols="12">
                  <v-data-table class="primary" :headers="headers" :items="armas" :search="buscaArma" calculate-widths>
                    <template v-slot:[`item.estatus`]="{ item }">
                      <span class="text-body-2">{{ item.CatEstatus.title }}</span>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                class="mr-2"
                                variant="secondary"
                                icon="mdi-update"
                                @click="openEstatusArmaDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Estatus arma</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton variant="secondary" icon="mdi-pencil" @click="openEditarArmaDialog(item)" />
                            </span>
                          </template>
                          <span>Editar arma</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import TextButton from '../../../base/TextButton.vue'
import { DIALOG_TYPES } from '../../../../plugins/dialog-types'
import IconButton from '../../../base/IconButton.vue'

export default {
  components: {
    TextButton,
    IconButton,
  },

  data() {
    return {
      headers: [
        { text: 'Tipo', value: 'CatClase.CatTipo.title', width: '10%' },
        { text: 'Marca', value: 'CatModelo.CatMarca.title', width: '10%' },
        { text: 'Modelo', value: 'CatModelo.modelo', width: '5%' },
        { text: 'Folio', value: 'folio', width: '10%' },
        { text: 'Matrícula', value: 'matricula', width: '10%' },
        { text: 'No. económico', value: 'noEconomico', width: '10%' },
        { text: 'Armero', value: 'armeros', width: '10%' },
        { text: 'Fecha alta LOC', value: 'fechaAltaLoc', width: '10%' },
        { text: 'Estatus', value: 'estatus', width: '15%', sortable: false },
        { text: 'Opciones', value: 'opciones', align: 'right', sortable: false },
      ],
      selectedArma: null,
      buscaArma: '',
      DIALOG_TYPES,
    }
  },

  computed: {
    ...mapGetters('arma', {
      armas: 'getArmas',
    }),
  },

  methods: {
    ...mapActions('claseArma', ['fetchClasesArma']),
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('arma', ['SET_SELECTED_ARMA']),

    openEstatusArmaDialog(arma) {
      this.SET_SELECTED_ARMA(arma)
      this.SET_DIALOG(DIALOG_TYPES.ESTATUS_ARMA_DIALOG_COMPONENT)
    },

    async openEditarArmaDialog(arma) {
      await this.fetchClasesArma(arma.CatClase.fk_idTipo)
      await this.fetchModeloArmas(arma.CatModelo.fk_idMarca)

      this.SET_SELECTED_ARMA(arma)
      this.SET_DIALOG(this.DIALOG_TYPES.EDITAR_ARMA_DIALOG_COMPONENT)
    },
    openRegistroArmaDialog() {
      this.SET_DIALOG(DIALOG_TYPES.RESGITRO_ARMA_NUEVA)
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para InventarioTabContent */
.card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

/* Título */
.v-card-title {
  color: #e0e0e0 !important;
  font-weight: 600;
}

/* Tabla de datos */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: rgba(108, 92, 231, 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.1) !important;
  transform: scale(1.01);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
  color: #e0e0e0 !important;
}

/* Texto del cuerpo */
.text-body-2 {
  color: #e0e0e0 !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #6c5ce7 !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #e0e0e0 !important;
}

/* ==================== SCROLLBAR ==================== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}

/* ==================== BOTONES CON RIPPLE ==================== */
::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

/* ==================== ANIMACIÓN ==================== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: fadeInUp 0.6s ease-out;
}
</style>
